<div class="card">
  <div class="card-header">
    <div class="d-flex flex-wrap justify-content-between align-items-center w-100">
      <h3 class="fw-bold my-2">{{ 'companyProfile.documents.title' | translate }}</h3>
      <app-button
        [variant]="'primary'"
        [label]="'companyProfile.documents.upload' | translate"
        [iconClass]="'fa fa-upload'"
        (clicked)="openAddModal()"
      />
    </div>
  </div>
  <div class="card-body">
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center py-10">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">{{ 'companyProfile.documents.loading' | translate }}</span>
        </div>
      </div>
    } @else if (documents.length === 0) {
      <div class="text-center py-15">
        <i class="fa fa-file-alt fs-3x text-muted mb-5"></i>
        <h4 class="text-muted">{{ 'companyProfile.documents.noDocuments' | translate }}</h4>
        <p class="text-muted mb-5">{{ 'companyProfile.documents.noDocumentsHint' | translate }}</p>
        <app-button
          [label]="'companyProfile.documents.upload' | translate"
          [variant]="'primary'"
          [iconClass]="'fa fa-upload'"
          (clicked)="openAddModal()"
        />
      </div>
    } @else {
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead>
            <tr>
              <th class="min-w-200px">{{ 'companyProfile.documents.tableDocument' | translate }}</th>
              <th class="min-w-100px">{{ 'companyProfile.documents.tableSize' | translate }}</th>
              <th class="min-w-150px">{{ 'companyProfile.documents.tableUploaded' | translate }}</th>
              <th class="text-end min-w-100px">{{ 'companyProfile.documents.tableActions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (doc of documents; track doc.document_id) {
              <tr>
                <td>
                  <div class="d-flex align-items-center">
                    <div class="document-icon me-3">
                      <i class="fa {{ getFileIcon(doc.file_extension) }} fs-2"></i>
                    </div>
                    <div>
                      <div class="fw-semibold text-gray-800">{{ doc.document_name }}</div>
                    </div>
                  </div>
                </td>
                <td class="text-muted">{{ formatFileSize(doc.file_size) }}</td>
                <td class="text-muted">{{ doc.created_at | date:'mediumDate' }}</td>
                <td class="text-end">
                  <div class="d-flex justify-content-end gap-1">
                    <app-button
                      [variant]="'ghost'"
                      [iconClass]="'fa fa-download'"
                      [size]="'sm'"
                      (clicked)="downloadDocument(doc)"
                    />
                    <app-button
                      [variant]="'ghost'"
                      [iconClass]="'fa fa-edit'"
                      [size]="'sm'"
                      (clicked)="openEditModal(doc)"
                    />
                    <app-button
                      [variant]="'ghost'"
                      [iconClass]="'fa fa-trash text-danger'"
                      [size]="'sm'"
                      (clicked)="deleteDocument(doc)"
                    />
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>
